import SelectOption from './selectOption';
import StaticVar from './staticVar';

const Utils = {
  SelectOption: SelectOption,
  StaticVar: StaticVar,
};

export default Utils;
